import { Role } from './role.model';

export class User {
  id: String;
  full_name: String;
  first_name: String;
  last_name: String;
  email: String;
  password: String;
  role_id: Role;
  profile_pic: String;
  role: String;
  project_id: string;
  project_name: String;
  project_manager_id: string;

  constructor() {
    this.id = '';
    this.full_name = '';
    this.first_name = '';
    this.last_name = '';
    this.email = '';
    this.password = '';
    this.role_id = new Role();
    this.profile_pic = '';
    this.role = '';
    this.project_id = '';
    this.project_name = '';
    this.project_manager_id = '';
  }
}
